// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__Tax from "../../grpc/Tax.js";
import * as Buhta_cabinet__TaxControl from "../../grpc/TaxControl.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as Luxon from "../../../../../packages/util/lib/bindings/Luxon.js";
import * as MelNumeral from "../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TaxPaymentsPage(Props) {
  let org = Props.org;
  let openMenu = Props.openMenu;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const match$1 = React.useState(function () {
    return false;
  });
  const setIsOnBoarded = match$1[1];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match$2 = React.useState(function () {
    return 0.0;
  });
  const setTaxSum = match$2[1];
  const paymentMonth = DateTime.month(DateTime.minus({
    NAME: "Duration",
    VAL: Luxon.Duration.from(undefined, undefined, undefined, undefined, 1, undefined, undefined, undefined, undefined)
  }, DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)));
  const paymentYear = DateTime.year(DateTime.minus({
    NAME: "Duration",
    VAL: Luxon.Duration.from(undefined, undefined, undefined, undefined, 1, undefined, undefined, undefined, undefined)
  }, DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)));
  const paymentMonthName = DateTime.monthName(DateTime.minus({
    NAME: "Duration",
    VAL: Luxon.Duration.from(undefined, undefined, undefined, undefined, 1, undefined, undefined, undefined, undefined)
  }, DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)));
  const func = Buhta_cabinet__TaxControl.TaxInformationService.view;
  const match$3 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._2(func, param, /* [] */ 0);
  }), undefined);
  const dispatchSettingsOrg = match$3[1];
  const settingsOrg = match$3[0];
  const func$1 = Buhta_cabinet__TaxControl.ChiefInformationService.view;
  const match$4 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._2(func$1, param, /* [] */ 0);
  }), undefined);
  const dispatchSettingsCeo = match$4[1];
  const settingsCeo = match$4[0];
  const arg = Curry._3(Buhta_cabinet__Tax.Period.make, paymentYear, {
    NAME: "Month",
    VAL: paymentMonth
  }, undefined);
  const func$2 = Buhta_cabinet__Tax.PayrollTaxService.calculate;
  const match$5 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func$2, param, false, arg);
  }), undefined);
  const dispatchCalculate = match$5[1];
  const calculation = match$5[0];
  React.useEffect((function () {
    Curry._2(dispatchSettingsCeo, undefined, undefined);
    Curry._2(dispatchSettingsOrg, undefined, undefined);
    Curry._2(dispatchCalculate, undefined, undefined);
  }), []);
  React.useEffect((function () {
    if (typeof settingsOrg === "string" || !(settingsOrg.NAME === "Data" && !(typeof settingsCeo === "string" || !(settingsCeo.NAME === "Data" && settingsOrg.VAL.kogd !== "" && settingsCeo.VAL.salary !== undefined)))) {
      
    } else {
      Curry._1(setIsOnBoarded, (function (param) {
        return true;
      }));
    }
  }), [
    settingsOrg,
    settingsCeo
  ]);
  React.useEffect((function () {
    let tax_sum;
    if (typeof calculation === "string") {
      tax_sum = 0;
    } else if (calculation.NAME === "Data") {
      const calculation$1 = calculation.VAL;
      console.log("calculation", calculation$1);
      const chief = calculation$1.chief;
      let chief_sum;
      if (chief !== undefined) {
        const __x = chief.earnings;
        chief_sum = Belt__Belt_List.reduce(__x, 0.0, (function (acc, earning) {
          const __x = earning.payroll_deductions;
          const deduction_sum = Belt__Belt_List.reduce(__x, 0.0, (function (acc, tax) {
            return Caml_format.caml_float_of_string(Belt__Belt_Option.getWithDefault(tax.amount, "0")) + acc;
          }));
          const __x$1 = earning.payroll_taxes;
          const tax_sum = Belt__Belt_List.reduce(__x$1, 0.0, (function (acc, tax) {
            return Caml_format.caml_float_of_string(Belt__Belt_Option.getWithDefault(tax.amount, "0")) + acc;
          }));
          return deduction_sum + tax_sum + acc;
        }));
      } else {
        chief_sum = 0;
      }
      const __x$1 = calculation$1.employees;
      const employees_sum = Belt__Belt_List.reduce(__x$1, 0.0, (function (acc, employee) {
        const __x = employee.earnings;
        const employee_sum = Belt__Belt_List.reduce(__x, 0.0, (function (acc, earning) {
          const __x = earning.payroll_deductions;
          const deduction_sum = Belt__Belt_List.reduce(__x, 0.0, (function (acc, tax) {
            return Caml_format.caml_float_of_string(Belt__Belt_Option.getWithDefault(tax.amount, "0")) + acc;
          }));
          const __x$1 = earning.payroll_taxes;
          const tax_sum = Belt__Belt_List.reduce(__x$1, 0.0, (function (acc, tax) {
            return Caml_format.caml_float_of_string(Belt__Belt_Option.getWithDefault(tax.amount, "0")) + acc;
          }));
          return deduction_sum + tax_sum + acc;
        }));
        return acc + employee_sum;
      }));
      tax_sum = chief_sum + employees_sum;
    } else {
      tax_sum = 0;
    }
    Curry._1(setTaxSum, (function (param) {
      return tax_sum;
    }));
  }), [calculation]);
  const icon = JsxRuntime.jsx("img", {
    className: "w-6 h-6",
    src: StaticAsset.src("/static/icons/cash-white-24.svg")
  });
  const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
      title: "Платежи",
      leftChildren: icon,
      openMenu: openMenu
    }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: "Платежи",
      arrowBack: false
    });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: match$1[0] ? JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                  className: "text-gray-medium font-mediumbold",
                  children: "ОСНОВНЫЕ ПЛАТЕЖИ"
                }),
                JsxRuntime.jsx(React.Fragment, {
                  children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                  alt: "buhta-people",
                                  src: StaticAsset.src("/static/icons/people-gray-32.svg")
                                }),
                                JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                      children: "Налоги за руководителя и сотрудников"
                                    }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "text-gray-medium",
                                      children: "за " + (paymentMonthName + (" " + String(paymentYear)))
                                    })
                                  ]
                                })
                              ],
                              className: "flex gap-2 items-start"
                            }),
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                  className: "text-alert",
                                  children: "Оплатите до 25 " + DateTime.toFormat("MMMM", DateTime.setLocale("ru", DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)))
                                }),
                                JsxRuntime.jsx("img", {
                                  className: "w-5 h-5",
                                  alt: "calendar-orange",
                                  src: StaticAsset.src("/static/icons/calendar-orange.svg")
                                })
                              ],
                              className: "flex gap-2"
                            })
                          ],
                          className: "flex gap-2 justify-between"
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: "text-gray-medium",
                                  children: "Итого"
                                }),
                                JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                  children: MelNumeral.format({
                                    NAME: "Float",
                                    VAL: match$2[0]
                                  }) + " ₸"
                                })
                              ]
                            }),
                            JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                              kind: "default",
                              className: "flex gap-1 items-center w-[105px] !px-3 !py-2",
                              onClick: (function (param) {
                                Buhta_cabinet__Route.navigateTo(contextRoute({
                                  TAG: /* Tax */ 4,
                                  _0: {
                                    TAG: /* Payments */ 0,
                                    _0: {
                                      TAG: /* Orders */ 0,
                                      _0: /* Index */ 0
                                    }
                                  }
                                }));
                              }),
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                  children: "К оплате"
                                }),
                                JsxRuntime.jsx("img", {
                                  className: "w-4 h-4",
                                  alt: "chevron right",
                                  src: StaticAsset.src("/static/icons/arrow-right-16.svg")
                                })
                              ]
                            })
                          ],
                          className: "flex justify-between items-end"
                        })
                      ],
                      className: "flex flex-col gap-4"
                    }),
                    className: "py-4 px-6 border border-gray-light rounded-lg"
                  })
                })
              ],
              className: "space-y-4 border-r p-6 w-2/3"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                    className: "text-default-gray",
                    children: "История платежей"
                  }),
                  className: "py-3 px-6"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                        className: "w-30 h-30",
                        src: StaticAsset.src("/static/images/cart-empty.png")
                      }),
                      className: "flex justify-center mt-10"
                    }),
                    JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                      className: "text-asphalt text-center mt-6",
                      children: "Вы еще не оплачивали налоги"
                    }),
                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "text-asphalt text-center mt-2",
                      children: "История ваших платежей появится после первой оплаты"
                    })
                  ],
                  className: "flex flex-col items-center"
                })
              ],
              className: "w-1/3"
            })
          ],
          className: "flex w-full h-full"
        }),
        className: "h-full"
      }) : JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                        className: "w-6 h-6",
                        src: StaticAsset.src("/static/icons/buildings-gray-24.svg")
                      }),
                      className: "rounded-full p-2 bg-gray-pale"
                    }),
                    JsxRuntime.jsx("hr", {
                      className: "w-20"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                        className: "w-6 h-6",
                        src: StaticAsset.src("/static/icons/user.svg")
                      }),
                      className: "rounded-full p-2 bg-gray-pale"
                    }),
                    JsxRuntime.jsx("hr", {
                      className: "w-20"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                        className: "w-6 h-6",
                        src: StaticAsset.src("/static/icons/people-gray-32.svg")
                      }),
                      className: "rounded-full p-2 bg-gray-pale"
                    })
                  ],
                  className: "flex gap-4 items-center"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs(Buhta_components__Text.H3.make, {
                      className: "text-asphalt-dark",
                      children: [
                        "Для начала работы с платежами и отчетностью — ",
                        JsxRuntime.jsx("br", {}),
                        "необходимо заполнить данные о предприятии и руководителе"
                      ]
                    }),
                    JsxRuntime.jsx(Buhta_components__Text.P.make, {
                      className: "text-gray-medium",
                      children: "Так мы сможем автоматически считать налоги"
                    })
                  ],
                  className: "space-y-1"
                }),
                JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                  route: contextRoute({
                    TAG: /* Tax */ 4,
                    _0: {
                      TAG: /* Payments */ 0,
                      _0: /* Settings */ 1
                    }
                  }),
                  className: "bg-primary hover:bg-primary-hover active:bg-primary-active py-2 px-4 rounded-sm flex gap-1 items-center w-full md:w-max justify-center md:justify-start",
                  children: [
                    JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                      className: "text-white -translate-y-[1px]",
                      children: "Начать"
                    }),
                    JsxRuntime.jsx("img", {
                      className: "w-4 h-4",
                      alt: "chevron right",
                      src: StaticAsset.src("/static/icons/chevron-right-white-16.svg")
                    })
                  ]
                })
              ],
              className: "space-y-6 md:border-r py-10 px-4 md:p-6 md:grow border-b md-border-b-0"
            }),
            className: "flex flex-col md:flex-row md:h-[422px] w-full"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                className: "text-default-gray mb-4",
                children: "История платежей"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("img", {
                  className: "w-30 h-30",
                  src: StaticAsset.src("/static/images/cart-empty.png")
                }),
                className: "flex justify-center mt-10"
              }),
              JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                className: "text-asphalt text-center mt-6",
                children: "Вы еще не оплачивали налоги"
              }),
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "text-asphalt text-center mt-2",
                children: "История ваших платежей появится после первой оплаты"
              })
            ],
            className: "py-10 px-4 md:py-3 md:px-6"
          })
        ]
      }),
    className: "flex-col"
  });
}

const make = TaxPaymentsPage;

export {
  make,
}
/* Buhta_cabinet__Button Not a pure module */
